import React from 'react';

import useAppIncidents from './useAppIncidents';
import Incidents from '../Incidents';

type AppIncidentsProps = {
  /** Implementation IDs (fka Selected API) to fetch incidents for. */
  implementationIds: string[];
};

/** Fetches and displays unresolved incidents for a given set of apps.  */
const AppIncidents = ({ implementationIds }: AppIncidentsProps) => {
  const { data } = useAppIncidents(implementationIds);

  if (!data) {
    return null;
  }

  const title =
    data.length > 1
      ? 'Status issues with one or more of these Apps may affect your Zap'
      : 'Status issues with one of these Apps may affect your Zap';

  return <Incidents incidents={data} title={title} />;
};

export default AppIncidents;
